import { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Page,
  Msg,
  LoadMore,
  Toast,
  Panel,
  PanelBody,
  MediaBox
} from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import TopNav from 'components/topNav.js';
import ClearIcon from '@material-ui/icons/Clear';
import * as MobileActions from 'actions/index.ts';
import useList from 'hooks/useList';
import CommonFns from 'functions/common.ts';

function InnerInquiryList(props) {
  const Config = {
    purchase: {
      apiPath: '/inquiry/inner/order/page',
      companyNameKey: 'innerVendorName',
      detailLink: '/mp/purchase/inquiry/inner/detail',
      searchBarPlaceholder: '询价编号/标题/物料名称/物料编号/物料规格',
      tabs: ['全部', '已发布'],
      countApi: '/inquiry/inner/order/getInnerCount',
      arrEnumField: [
        {
          mainKey: 'B02_Inner_Inquiry_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Inquiry_Operate_Status',
          subKey: 'operateStatus',
          value: 'operateStatusName'
        },
        {
          mainKey: 'B02_Inquiry_Bill_Type',
          subKey: 'billType',
          value: 'billTypeName'
        }
      ],
      countTransform: (data, self) => {
        //分类统计 [1 已发布]
        let { 1: a } = data;
        setCount([undefined, a]);
      },
      tabConfig: [
        [], //全部
        [1] // 已发布
      ]
    }
  };
  const config = Config[props.type];
  const {
    companyCode,
    searchKey,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    showLoading,
    list,
    count,
    setCount,
    handleTab,
    handleChange,
    handleClear,
    self
  } = useList(props, config);

  //初始化默认企业
  useEffect(() => {
    self.init();
  }, [self]);

  //companyCode改变时执行
  useEffect(() => {
    self.getCount();
  }, [companyCode, self]);

  //根据依赖多次执行
  useEffect(() => {
    self.search();
  }, [searchKey, companyCode, currentTab, self]);

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  return (
    <Page
      transition={false}
      ptr={false}
      onLoadMore={(resolveLoading, finish) => {
        self.pageResolveLoading = resolveLoading;
        if (list.length >= total) {
          finish();
        } else {
          self.search();
        }
      }}
      className="v2"
    >
      <TopNav
        inited={inited}
        onSubmit={handleChange}
        onCancel={handleClear}
        onClear={handleClear}
        defaultValue={searchKey}
        placeholder={config.searchBarPlaceholder}
      />
      <Panel>
        {dataError !== null ? (
          <Msg {...dataError} />
        ) : (
          <span>
            <div className="m-tab-container">
              <ul className="m-flex-box">
                {config.tabs.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleTab(index);
                    }}
                    className={
                      currentTab === index ? 'm-flex-item curr' : 'm-flex-item'
                    }
                  >
                    <span className="name">{item}</span>
                    {count[index] && (
                      <sup className="u-num">{count[index]}</sup>
                    )}
                  </li>
                ))}
              </ul>
              {searchKey && (
                <div className="searchKeyBox">
                  查询信息：
                  <div onClick={handleClear}>
                    <span className="singleOmission">{searchKey}</span>
                    <ClearIcon
                      className="verticalMiddle"
                      color="primary"
                      fontSize="inherit"
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="list-total">{total}</div>
            <div className="m-details-item">
              <div className="details-item-content">
                {updateTs > 0 &&
                  list.map((item, index) => (
                    <Link
                      to={`${config.detailLink}/${companyCode}/${item.inqXkNo}`}
                      key={index}
                      className="content-line line-list-item"
                    >
                      <div className="line-list-item-title">
                        <span>{item.inqInnerNo}</span>
                        <div className="more">
                          <span
                            className={
                              'u-sign ' +
                              CommonFns.getStatusClass(
                                'innerInquiry',
                                item.status
                              )
                            }
                          >
                            {item.statusName}
                          </span>
                        </div>
                      </div>
                      <ul className="field-list">
                        <li>
                          <label>标题</label>
                          <div>{item.billTitle}</div>
                        </li>
                        <li>
                          <label>需求企业</label>
                          <div>{item.inquiryCompanyName}</div>
                        </li>
                        <li>
                          <label>询价企业</label>
                          <div>{item.productCompanyName}</div>
                        </li>
                        <li>
                          <label>询价类型</label>
                          <div className="blue">{item.billTypeName}</div>
                        </li>
                        <li>
                          <label>发布人</label>
                          <div>{item.publishName}</div>
                        </li>
                        <li>
                          <label>发布时间</label>
                          <div>{formatDate(item.publishTime)}</div>
                        </li>
                        <li>
                          <label>截止时间</label>
                          <div>{formatDate(item.endDate)}</div>
                        </li>
                        <li>
                          <label>处理状态</label>
                          <div>
                            <span
                              className={
                                'u-sign ' +
                                CommonFns.getStatusClass(
                                  'innerInquiryOperate',
                                  item.operateStatus
                                )
                              }
                            >
                              {item.operateStatusName}
                            </span>
                          </div>
                        </li>
                      </ul>
                    </Link>
                  ))}
                {!showLoading && list.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </div>
            </div>
          </span>
        )}
      </Panel>
      <Toast icon="loading" show={showLoading}>
        数据加载中...
      </Toast>
    </Page>
  );
}

InnerInquiryList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(InnerInquiryList);
